import React from 'react';
import PropTypes from 'prop-types';

const { node, string, bool } = PropTypes;

/**  */
export default class A11yFocus extends React.Component {
  static propTypes = {
    children: node,
    onFocusClassName: string,
    // eslint-disable-next-line react/boolean-prop-naming
    passA11yFocusProp: bool
  };

  static defaultProps = {
    children: null,
    onFocusClassName: '',
    passA11yFocusProp: false
  };

  constructor(props) {
    super(props);

    this.mouseActive = false;
    this.state = {
      a11yFocus: false
    };
  }

  onMouseDown = childOnMouseDown => e => {
    this.mouseActive = true;
    if (childOnMouseDown) {
      childOnMouseDown(e);
    }
  };

  onClick = childOnClick => e => {
    // From https://www.w3.org/TR/2012/WD-html5-20121025/content-models.html#interactive-content
    // Only remove focus on mouse event
    this.setState({
      a11yFocus: e.clientX === 0 && e.clientY === 0
    });

    if (childOnClick) {
      childOnClick(e);
    }
  };

  onFocus = childOnFocus => e => {
    // Only  focus on a tab key event
    this.setState({
      a11yFocus: !this.mouseActive
    });

    if (childOnFocus) {
      childOnFocus(e);
    }
  };

  onBlur = childOnBlur => e => {
    this.mouseActive = false;
    this.setState({
      a11yFocus: false
    });
    if (childOnBlur) {
      childOnBlur(e);
    }
  };

  render() {
    const { onBlur, onFocus, onClick, onMouseDown } = this;
    const {
      children,
      // eslint-disable-next-line react/prop-types
      className,
      // eslint-disable-next-line react/prop-types
      style,
      onFocusClassName,
      passA11yFocusProp
    } = this.props;

    let rtn = [];

    if (React.Children.count(children) === 1) {
      rtn = React.Children.map(children, child => {
        // merge class names from prop, onFocusClassName prop and child class
        const propClassName = className || '';
        const propOnFocusClassName = this.state.a11yFocus
          ? onFocusClassName
          : '';
        const childClassName = child.props.className || '';

        const newChildProps = {
          ...child.props,
          className: `${childClassName} ${propOnFocusClassName} ${propClassName}`.trim(),
          style: { ...style, ...child.props.style }, // merge style object from prop and child prop
          a11yFocus: this.state.a11yFocus,
          onBlur: onBlur(child.props.onBlur),
          onFocus: onFocus(child.props.onFocus),
          onClick: onClick(child.props.onClick),
          onMouseDown: onMouseDown(child.props.onMouseDown)
        };
        // Pass a11yFocus prop only if passA11yFocusProp is set to true
        if (!passA11yFocusProp) {
          delete newChildProps.a11yFocus;
        }

        if (this.state.a11yFocus) {
          newChildProps['data-a11yfocus'] = true;
        } else {
          delete newChildProps['data-a11yfocus'];
        }

        return React.cloneElement(child, newChildProps);
      });
    }

    return rtn[0];
  }
}
